// extracted by mini-css-extract-plugin
module.exports = {"singleCheckboxFilter":"SingleCheckboxFilter_singleCheckboxFilter__SvS-Q","disabled":"SingleCheckboxFilter_disabled__1Egj8"};